import React from "react"
import { SelectSeeker } from "@ui-seeker/core"

import { lengthRental } from "@signals"


export default function LengthOfRentalSelect({ ...props }) {
    return <SelectSeeker
		label="Length of Rental"
		placeholder="Length of Rental"
		value={lengthRental.value}
		onChange={e => lengthRental.value = e.target.value}
		options={[
			{ label: '1', value: '1' },
			{ label: '3', value: '3' },
			{ label: '5', value: '5' }
		]}
		{...props}
	/>
}